import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import {Table, Button} from 'antd';
import noData from './assets/nodata.png';
import {ColumnsType} from 'antd/lib/table';
import {paginationSize} from '@helpers/misc/setPaginationSize';
import styles from './HistoryOrders.module.scss';
import {AuditHistory} from "@ui/auditReport";


interface Props {
    dataSource: AuditHistory[] | undefined;
}

const HistoryOrders = ({dataSource}: Props) => {
    const [paginationData, setPaginationData] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const getAuditReport = async (record: AuditHistory) => {
        const baseURL = process.env.REACT_APP_HOST || 'https://contentsuite.derbysoft-test.com/content-manager'
        const href = baseURL + `/reports/download/audit/` + record.fileName;
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'content-report.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const columns: ColumnsType<AuditHistory> = [
        {
            title: 'Order Number',
            dataIndex: 'orderNumber',
            key: 'orderNumber',
        },
        {
            title: 'Report Name',
            dataIndex: 'reportName',
            key: 'reportName',
        },
        {
            title: 'Supplier',
            dataIndex: 'supplier',
            key: 'supplier',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center' as 'center',
            render: (text: string, record: AuditHistory, index: number) => (
                record.status === "Completed" && <>
                    <span  onClick={() => {
                        getAuditReport(record)
                    }} style={{color: '#06789D', cursor: 'pointer'}}>Download</span>
                </>
            ),
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },

        {
            title: 'Requested At',
            dataIndex: 'requestedAt',
            key: 'requestedAt',
        },

        {
            title: 'Request User',
            dataIndex: 'requester',
            key: 'requester',
        },
    ];

    // @ts-ignore
    return (
        <>
            <Grid
                item
                xs={12}
                className="p-0"
            >
                <Table
                    columns={columns}
                    locale={{
                        emptyText: (
                            <>
                                <img
                                    src={noData}
                                    alt="no data"
                                    style={{marginTop: 56, marginBottom: 24}}
                                />
                                <div style={styles.noData}>
                                    Content Audit Report provides a full view of the content{' '}
                                    <br/> provided by a hotel supplier.
                                </div>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                    }}
                                    style={{
                                        color: '#fff',
                                        textAlign: 'center',
                                        fontSize: 14,
                                        fontStyle: 'normal',
                                        fontWeight: 600,
                                        lineHeight: 'normal',
                                        marginTop: 24,
                                        backgroundColor: '#004771',
                                        height: 40,
                                        width: 'auto',
                                    }}
                                >
                                    Create Content Audit Report
                                </Button>
                            </>
                        ),
                    }}
                    dataSource={dataSource}
                    pagination={{
                        pageSizeOptions: ['10', '20', '50', '100'],
                        showSizeChanger: true,
                        showTotal: (total, range) =>
                            `Total ${total} items, current ${range[0]}-${range[1]}`,
                        defaultPageSize: paginationData,
                        defaultCurrent: 1,
                        onShowSizeChange: (current, size: number) =>
                            paginationSize('pagination', {room_amenities: size}),
                        size: 'small',
                        total,
                    }}
                />
            </Grid>
        </>
    );
};

export default HistoryOrders;
